import React from 'react';

const MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

const SELECT_CLASS = 'rounded-md border border-[var(--border)] bg-white px-3 py-2 text-sm text-[var(--foreground)]';

export function currentSastPeriod(now = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Africa/Johannesburg',
    year: 'numeric',
    month: '2-digit',
  }).formatToParts(now);
  const year = parts.find((part) => part.type === 'year')?.value || '2026';
  const month = parts.find((part) => part.type === 'month')?.value || '01';
  return `${year}-${month}`;
}

function yearOptions(currentYear: number): number[] {
  const years: number[] = [];
  for (let year = currentYear; year >= currentYear - 4; year -= 1) {
    years.push(year);
  }
  return years;
}

interface MonthPeriodMenuProps {
  idPrefix: string;
  value: string;
  onChange: (period: string) => void;
}

export const MonthPeriodMenu: React.FC<MonthPeriodMenuProps> = ({ idPrefix, value, onChange }) => {
  const current = currentSastPeriod();
  const [currentYear, currentMonth] = current.split('-');
  const [year, month] = (value || current).split('-');
  const years = yearOptions(Number(currentYear));
  const months = year === currentYear
    ? MONTHS.filter((item) => item.value <= currentMonth)
    : MONTHS;

  const chooseMonth = (nextMonth: string) => {
    onChange(`${year}-${nextMonth}`);
  };

  const chooseYear = (nextYear: string) => {
    const nextMonth = nextYear === currentYear && month > currentMonth ? currentMonth : month;
    onChange(`${nextYear}-${nextMonth}`);
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <label className="text-sm text-[var(--muted-foreground)]" htmlFor={`${idPrefix}-month`}>Month</label>
      <select
        id={`${idPrefix}-month`}
        className={SELECT_CLASS}
        value={months.some((item) => item.value === month) ? month : currentMonth}
        onChange={(event) => chooseMonth(event.target.value)}
      >
        {months.map((item) => (
          <option key={item.value} value={item.value}>{item.label}</option>
        ))}
      </select>
      <label className="text-sm text-[var(--muted-foreground)]" htmlFor={`${idPrefix}-year`}>Year</label>
      <select
        id={`${idPrefix}-year`}
        className={SELECT_CLASS}
        value={year}
        onChange={(event) => chooseYear(event.target.value)}
      >
        {years.map((item) => (
          <option key={item} value={String(item)}>{item}</option>
        ))}
      </select>
    </div>
  );
};
